<template lang="html">
  <div id="tabelaPrecos">
    <table cellspacing="0" cellpadding="0" width="100%" border="0">
    <tr>	<th align="left">Tipo de certificado
      <th align="center">Validade</th>
    </tr>

    <tr>	
      <td>ACS PF DV Alpha</td>
      <td align="center">1 ano</td>
    </tr>
    <tr>	
      <td>ACS PF DV</td>
      <td align="center">1 ano</td>
    </tr>
    <tr>	
      <td>ACS PJ OV</td>
      <td align="center">1 ano</td>
    </tr>
    <tr>	
      <td>ACS PJ EV</td>
      <td align="center">1 ano</td>
    </tr>


    </table>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped="true">

td,th {
  border-bottom: #aaa solid 1px !important;
  padding: 5px 0 5px 0 !important;
}

</style>



// WEBPACK FOOTER //
// Precos.vue?48b72c1e